<mat-card>
    <div class="content-header">
        <div class="container-fluid">
            <h1 class="m-0 text-dark">{{nomModule}}</h1>
        </div>
    </div>
    <div class="alert alert-dark" role="alert" style="    background: #343a40 !important;border-color: #292d32 !important;text-align: center;">
        {{textoInicioSesion}}
    </div>
</mat-card>